/**
 * 會計狀態 → StatusDot 色調對照（docs/介面優化.md R6，全系統只在這裡定義一次）
 * success 完成、warning 待處理、danger 逾期／異常、neutral 草稿／作廢、accent 進行中
 */
import type { StatusTone } from '@redpanda/ui';

export const toneOf = (map: Record<string, StatusTone>, value?: string | null): StatusTone =>
  (value && map[value]) || 'neutral';

/** 發票：草稿＝灰、已開立（待收款）＝主題色、已收款＝綠、逾期＝紅、作廢＝灰 */
export const invoiceTone: Record<string, StatusTone> = {
  DRAFT: 'neutral',
  SENT: 'accent',
  PAID: 'success',
  OVERDUE: 'danger',
  CANCELLED: 'neutral',
};

/** 結帳記錄：完成＝綠、進行中＝主題色、失敗＝紅、已重新開啟＝灰 */
export const closingTone: Record<string, StatusTone> = {
  COMPLETED: 'success',
  PROCESSING: 'accent',
  PENDING: 'warning',
  FAILED: 'danger',
  REOPENED: 'neutral',
};
